module.exports = __webpack_public_path__ + "static/media/18.e88f8081.png";